import HeaderBox from "../header-box";
import { Card, CardBody, Col, Container, Row, Form, Label, Input } from "reactstrap";
import InputField from "../../../../components/Common/Input";
import {useFormik} from "formik";
import validationSchema from "./validationSchema";
import { useMemo, useState } from "react";
import InputRadio from "../../../../components/Common/InputRadio";
import { Select } from "src/components/Common";
import { STATES_AND_COUNTRIES } from "src/common/constants";

const getDefaultBooleanValue = (value) => typeof value === 'boolean' ? value : "";

interface Props {
    data?: any;
    user?: any; // TODO: Define appropriate type
    deviceSerialNumber: string;
    isLoading: boolean;
    onNext: (_values: any) => void;
}

const DeviceSurveyForm = ({ data = null, user = null, onNext, deviceSerialNumber, isLoading }: Props) => {
    const form = useFormik({
        initialValues: {
            productSatisfaction: data?.productSatisfaction || "",
            productMeetsNeeds: data?.productMeetsNeeds || "",
            easeOfInformation: data?.easeOfInformation || "",
            easeOfUse: data?.easeOfUse || "",
            recommendProduct: data?.recommendProduct || "",
            additionalQuestions: data?.additionalQuestions || "",
            whatDealership: data?.whatDealership || "",
            dealershipExperience: data?.dealershipExperience || "",
            dealershipKnowledge: data?.dealershipKnowledge || "",
            recommendDealership: data?.recommendDealership || "",
            welcomeGift: data?.welcomeGift || "",
            hasManual: getDefaultBooleanValue(data?.hasManual),
            dealerReviewMaintenanceProcedures: getDefaultBooleanValue(data?.dealerReviewMaintenanceProcedures),
            dealerReviewSafetyProcedures: getDefaultBooleanValue(data?.dealerReviewSafetyProcedures),

            differentAddress: getDefaultBooleanValue(data?.differentAddress ?? false),

            fullName: data?.fullName || user?.firstName + " " + user?.lastName || "",
            address: data?.address || user?.address?.line1 || "",
            address2: data?.address2 || user?.address?.line2 || "",
            city: data?.city || user?.address?.city || "",
            state: data?.state || user?.address?.state || "",
            zip: data?.zip || user?.address?.zip || "",
        },
        validationSchema,
        validateOnMount: true,
        onSubmit: () => {
            onNext(form.values);
        },
    });

    const [differentAddress, setDifferentAddress] = useState(false);

    const isButtonDisabled = useMemo(() => !!Object.keys(form.errors).length, [form]);
    const states = useMemo(() => STATES_AND_COUNTRIES.map(({ State, StateCode }) => ({ label: State, value: StateCode })), [STATES_AND_COUNTRIES]);

    const onDifferentAddressChange = (e) => {
        setDifferentAddress(e.target.checked);
        form.setFieldValue("differentAddress", e.target.checked);
    };

    return (
        <>
            <HeaderBox
                title="Register Machine"
                serialNumber={deviceSerialNumber}
                isDisabled={isLoading}
            />

            <Card>
                <CardBody>
                    <Container fluid>
                        <Form
                            onSubmit={e => {
                                e.preventDefault();
                                form.handleSubmit();
                                return false;
                            }}
                        >
                            <Row>
                                <Col xs={12} className="font-size-18 fw-bold pb-3 text-uppercase">
                                  Fecon Customer Satisfaction Survey
                                </Col>
                                {/*
                                <Col xs={12} xl={12}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="1. How satisfied are you with your Fecon product?"
                                            name="productSatisfaction"
                                            form={form}
                                            disabled={true}
                                            options={[
                                              { label: "Very satisfied", value: "Very satisfied" },
                                              { label: "Satisfied", value: "Satisfied" },
                                              { label: "Neutral", value: "Neutral" },
                                              { label: "Dissatisfied", value: "Dissatisfied" },
                                              { label: "Very dissatisfied", value: "Very dissatisfied" },
                                            ]}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} xl={12}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="2. How well does the product meet your needs?"
                                            name="productMeetsNeeds"
                                            form={form}
                                            options={[
                                              { label: "Exceeds expectations", value: "Exceeds expectations" },
                                              { label: "Meets expectations", value: "Meets expectations" },
                                              { label: "Partially meets expectations", value: "Partially meets expectations" },
                                              { label: "Below expectations", value: "Below expectations" },
                                              { label: "Significantly below expectations", value: "Significantly below expectations" },
                                            ]}
                                        />
                                    </div>
                                </Col>
                                */}
                                <Col xs={12} xl={12}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="How easy was it to find product information and complete the purchasing process?"
                                            name="easeOfInformation"
                                            form={form}
                                            options={[
                                              { label: "Extremely easy", value: "Extremely easy" },
                                              { label: "Fairly easy", value: "Fairly easy" },
                                              { label: "Neutral", value: "Neutral" },
                                              { label: "Somewhat difficult", value: "Somehwat difficult" },
                                              { label: "Very difficult", value: "Very difficult" },
                                            ]}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} xl={12}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="How easy was it to use and set up your Fecon product?"
                                            name="easeOfUse"
                                            form={form}
                                            options={[
                                              { label: "Extremely easy", value: "extremely_easy" },
                                              { label: "Fairly easy", value: "fairly_easy" },
                                              { label: "Neutral", value: "neutral" },
                                              { label: "Somewhat difficult", value: "Somehwat difficult" },
                                              { label: "Very difficult", value: "Very difficult" },
                                            ]}
                                        />
                                    </div>
                                </Col>
                                {/*
                                <Col xs={12} xl={12}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="5. How likely are you to recommend our product to others?"
                                            name="recommendProduct"
                                            form={form}
                                            options={[
                                              { label: "10 - Extremely likely", value: "10" },
                                              { label: "9", value: "9" },
                                              { label: "8", value: "8" },
                                              { label: "7", value: "7" },
                                              { label: "6", value: "6" },
                                              { label: "5", value: "5" },
                                              { label: "4", value: "4" },
                                              { label: "3", value: "3" },
                                              { label: "2", value: "2" },
                                              { label: "1 - Not likely at all", value: "1" },
                                            ]}
                                        />
                                    </div>
                                </Col>
                                */}
                                <Col xs={12} xl={8}>
                                    <InputField
                                    className="mw-400 mb-3"
                                    name="additionalQuestions"
                                    label="Do you have any additional comments or suggestions?"
                                    form={form}
                                    value={form.values.additionalQuestions}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} className="font-size-18 fw-bold pb-3 text-uppercase">
                                  Dealership Experience
                                </Col>
                                <Col xs={12} xl={8}>
                                    <InputField
                                    className="mw-400 mb-3"
                                    name="whatDealership"
                                    label="What dealership did you purchase your Fecon product from?"
                                    form={form}
                                    value={form.values.whatDealership}
                                    />
                                </Col>
                                <Col xs={12} xl={12}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="How would you rate your overall experience with the dealership?"
                                            name="dealershipExperience"
                                            form={form}
                                            options={[
                                              { label: "Excellent", value: "Excellent" },
                                              { label: "Good", value: "Good" },
                                              { label: "Fair", value: "Fair" },
                                              { label: "Poor", value: "Poor" },
                                              { label: "Very poor", value: "Very poor" },
                                            ]}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} xl={12}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="How knowledgeable was the dealership staff regarding Fecon products?"
                                            name="dealershipKnowledge"
                                            form={form}
                                            options={[
                                              { label: "Extremely easy", value: "Extremely easy" },
                                              { label: "Fairly easy", value: "Fairly easy" },
                                              { label: "Neutral", value: "Neutral" },
                                              { label: "Somewhat difficult", value: "Somewhat difficult" },
                                              { label: "Very difficult", value: "Very difficult" },
                                            ]}
                                        />
                                    </div>
                                </Col>
                                {/*
                                <Col xs={12} xl={12}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="10. How likely are you to recommend this dealership to others?"
                                            name="recommendDealership"
                                            form={form}
                                            options={[
                                              { label: "10 - Extremely likely", value: "10" },
                                              { label: "9", value: "9" },
                                              { label: "8", value: "8" },
                                              { label: "7", value: "7" },
                                              { label: "6", value: "6" },
                                              { label: "5", value: "5" },
                                              { label: "4", value: "4" },
                                              { label: "3", value: "3" },
                                              { label: "2", value: "2" },
                                              { label: "1 - Not likely at all", value: "1" },
                                            ]}
                                        />
                                    </div>
                                </Col>
                                */}
                            </Row>

                            <Row>
                                <Col xs={12} className="font-size-18 fw-bold pb-3 text-uppercase">
                                    Machine Delivery Information
                                </Col>
                                <Col xs={12} xl={6}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="Did you receive an Operator's Manual with Safety Instructions?"
                                            name="hasManual"
                                            form={form}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} xl={6}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="Did the Dealer review Maintenance Procedures?"
                                            name="dealerReviewMaintenanceProcedures"
                                            form={form}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} xl={6}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="Did the Dealer review Safety Procedures?"
                                            name="dealerReviewSafetyProcedures"
                                            form={form}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            
                            <Row>
                                <Col xs={12} className="font-size-18 fw-bold pb-3 text-uppercase">
                                    Welcome Kit
                                </Col>
                                <Col xs={12} xl={12}>
                                    <div className="mb-3">
                                        <InputRadio
                                            label="Welcome Gift Option"
                                            name="welcomeGift"
                                            form={form}
                                            options={[
                                                { label: "Tune Up kit", value: "Tune Up Kit" },
                                                { label: "Fecon Swag kit", value: "Fecon Swag Kit" },
                                            ]}
                                        />
                                    </div>
                                </Col>
                                <Col className="mb-4">
                                    <Input type="checkbox" id="sameAddress" name="sameAddress" className="me-2" onChange={(e) => onDifferentAddressChange(e)} />
                                    <Label check for="sameAddress">
                                        Different shipping address for welcome kit? (Kit cannot be shipped to PO BOX)
                                    </Label>
                                </Col>
                            </Row>
                            
                            {differentAddress && (
                                <Row>
                                    <Col xs={12} xl={7}>
                                        <div className="mb-3">
                                            <InputField
                                                label="Full name"
                                                name="fullName"
                                                placeholder={"Full name"}
                                                form={form}
                                                value={form.values.fullName}
                                                disabled={data?.differentAddress}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={12} xl={6}>
                                        <div className="mb-3">
                                            <InputField
                                                label="Address"
                                                name="address"
                                                placeholder="Address"
                                                form={form}
                                                value={form.values.address}
                                                disabled={data?.differentAddress}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={12} xl={6}>
                                        <div className="mb-3">
                                            <InputField
                                                label="Address 2"
                                                name="address2"
                                                placeholder={"Address 2"}
                                                form={form}
                                                value={form.values.address2}
                                                disabled={data?.differentAddress}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={6} xl={3}>
                                        <div className="mb-3">
                                            <InputField
                                                label="City"
                                                name="city"
                                                placeholder="City"
                                                form={form}
                                                value={form.values.city}
                                                disabled={data?.differentAddress}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={6} xl={3}>
                                        <div className="mb-3">
                                            <Select
                                                name="state"
                                                label="State"
                                                placeholder="Select State"
                                                options={states}
                                                formik={form}
                                                value = {
                                                    states.filter(option =>
                                                        option.value === form.values.state
                                                    )
                                                }
                                                isDisabled={data?.differentAddress}
                                            ></Select>
                                        </div>
                                    </Col>
                                    <Col xs={6} xl={3}>
                                        <div className="mb-3">
                                            <InputField
                                                label="Zipcode"
                                                name="zip"
                                                placeholder="Zipcode"
                                                form={form}
                                                value={form.values.zip}
                                                disabled={data?.differentAddress}
                                            />
                                        </div>
                                    </Col>
                                </Row>)
                            }

                            <Row>
                                <Col>
                                    <div className="text-center mt-3">
                                        <button
                                            type="submit"
                                            className="btn btn-danger save-user"
                                            disabled={isLoading || isButtonDisabled}
                                        >
                                            SUBMIT
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </CardBody>
            </Card>
        </>
    );
};

export default DeviceSurveyForm;
